(() => {
  const INFO_SELECTOR = '.product__info-container';
  const ADD_BUTTON_SELECTOR =
    'button[name="add"], .product-form__submit';

  const BUY_NOW_BUTTON_SELECTOR =
    '.shopify-payment-button__button, ' +
    '.shopify-payment-button button';

  const BUY_NOW_WRAPPER_SELECTOR =
    '.shopify-payment-button';

  const INITIALISED_ATTRIBUTE = 'data-om-buy-now-guard';
  let toastTimer = null;

  function getAddButton(scope) {
    return scope.querySelector(ADD_BUTTON_SELECTOR);
  }

  function isSelectedVariantUnavailable(scope) {
    const addButton = getAddButton(scope);

    /*
     * If Dawn cannot provide a valid Add to Cart button,
     * treat the product as unavailable rather than allowing
     * a potentially incorrect direct checkout.
     */
    if (!addButton) {
      return true;
    }

    return (
      addButton.disabled === true ||
      addButton.getAttribute('aria-disabled') === 'true'
    );
  }

  function showUnavailableToast() {
    let toast = document.getElementById(
      'om-buy-now-stock-toast'
    );

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'om-buy-now-stock-toast';
      toast.className = 'om-buy-now-stock-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');

      document.body.appendChild(toast);
    }

    window.clearTimeout(toastTimer);

    toast.textContent =
      'This size is sold out. Please choose another available size.';

    toast.classList.add('is-visible');

    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function synchroniseBuyNow(scope) {
    const unavailable =
      isSelectedVariantUnavailable(scope);

    scope
      .querySelectorAll(BUY_NOW_WRAPPER_SELECTOR)
      .forEach((wrapper) => {
        wrapper.classList.toggle(
          'om-buy-now-unavailable',
          unavailable
        );

        wrapper.setAttribute(
          'data-om-buy-now-unavailable',
          unavailable ? 'true' : 'false'
        );
      });

    scope
      .querySelectorAll(BUY_NOW_BUTTON_SELECTOR)
      .forEach((button) => {
        button.disabled = unavailable;

        button.setAttribute(
          'aria-disabled',
          unavailable ? 'true' : 'false'
        );

        if (unavailable) {
          button.setAttribute('tabindex', '-1');
        } else {
          button.removeAttribute('tabindex');
        }
      });
  }

  function initialiseProductScope(scope) {
    if (
      !scope ||
      scope.getAttribute(INITIALISED_ATTRIBUTE) === 'true'
    ) {
      return;
    }

    scope.setAttribute(INITIALISED_ATTRIBUTE, 'true');

    const addButton = getAddButton(scope);

    if (addButton) {
      const addButtonObserver = new MutationObserver(() => {
        synchroniseBuyNow(scope);
      });

      addButtonObserver.observe(addButton, {
        attributes: true,
        attributeFilter: [
          'disabled',
          'aria-disabled',
          'class'
        ]
      });
    }

    /*
     * Shopflo or Shopify may insert/rebuild the Buy Now
     * button asynchronously, so watch for newly added nodes.
     */
    const scopeObserver = new MutationObserver(() => {
      synchroniseBuyNow(scope);
    });

    scopeObserver.observe(scope, {
      childList: true,
      subtree: true
    });

    synchroniseBuyNow(scope);
  }

  function initialiseAllProductScopes(root = document) {
    root
      .querySelectorAll(INFO_SELECTOR)
      .forEach(initialiseProductScope);
  }

  /*
   * Recheck immediately after any size/variant selection.
   */
  document.addEventListener(
    'change',
    (event) => {
      const scope = event.target.closest(INFO_SELECTOR);

      if (!scope) {
        return;
      }

      window.setTimeout(() => {
        synchroniseBuyNow(scope);
      }, 0);

      window.setTimeout(() => {
        synchroniseBuyNow(scope);
      }, 150);
    },
    true
  );

  /*
   * Capture Buy Now clicks before Shopflo or another
   * checkout script can redirect the customer.
   */
  document.addEventListener(
    'click',
    (event) => {
      const buyNowButton = event.target.closest(
        BUY_NOW_BUTTON_SELECTOR
      );

      if (!buyNowButton) {
        return;
      }

      const scope = buyNowButton.closest(INFO_SELECTOR);

      if (
        !scope ||
        !isSelectedVariantUnavailable(scope)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      buyNowButton.blur();
      showUnavailableToast();
    },
    true
  );

  /*
   * Secondary protection in case Buy Now submits a form
   * instead of redirecting directly from its click handler.
   */
  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;

      if (
        !submitter ||
        !submitter.matches(BUY_NOW_BUTTON_SELECTOR)
      ) {
        return;
      }

      const scope = submitter.closest(INFO_SELECTOR);

      if (
        !scope ||
        !isSelectedVariantUnavailable(scope)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      showUnavailableToast();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialiseAllProductScopes()
    );
  } else {
    initialiseAllProductScopes();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAllProductScopes(event.target);
    }
  );

  /*
   * Detect sections/buttons inserted later by Shopify apps.
   */
  const documentObserver = new MutationObserver(() => {
    initialiseAllProductScopes();
  });

  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();